import { createSlice } from "@reduxjs/toolkit";
import * as actions from "../action/products";
import { productResponse, productDetailResponse } from "../../types/products";
import Toast from "../../helpers/Toast";

type InitialState = {
  productRegister: productResponse[];
  productPurchase: productResponse[];
  productDetail: productDetailResponse;
};

const initialState: InitialState = {
  productRegister: [],
  productPurchase: [],
  productDetail: {} as productDetailResponse,
};

const productsSlice = createSlice({
  name: "product",
  initialState: initialState,
  reducers: {
    resetProduct: () => initialState,
  },

  extraReducers(builder) {
    builder
      .addCase(actions.getProductsRegisterList.fulfilled, (state, action) => {
        state.productRegister = action.payload;
      })
      .addCase(actions.getProductsRegisterList.rejected, (state, action) => {
        state.productRegister = [];
        Toast.fire({
          icon: "error",
          title: "Fail to get Product List",
        });
      })

      .addCase(actions.getProductsPurchaseList.fulfilled, (state, action) => {
        state.productPurchase = action.payload;
      })
      .addCase(actions.getProductsPurchaseList.rejected, (state, action) => {
        state.productPurchase = [];
        Toast.fire({
          icon: "error",
          title: "Fail to get Product List",
        });
      })

      .addCase(actions.getProductDetailById.fulfilled, (state, action) => {
        state.productDetail = action.payload;
      })
      .addCase(actions.getProductDetailById.rejected, (state, action) => {
        state.productDetail = {} as productDetailResponse;
        Toast.fire({
          icon: "error",
          title: "Fail to get Product Detail",
        });
      });
  },
});

export const {} = productsSlice.actions;
export default productsSlice.reducer;
